import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ExpensesClassificationType  {
    _originalTypeClassName = "zERP.BO.ExpensesClassificationType";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ExpensesClassificationType.translate = translateService;
}
this.Id = null;
this.Amount = null;
this.ERPAA = null;
this.ERPDocID = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Amount:any;
ERPAA:any;
ERPDocID:any;
ClassificationType:any;
InvoicesExpensesClassificationDetailType:any;
ERPInvoiceCategory:any;
ERPInvoiceType:any;
ClassificationCategory:any;
InvoiceSummaryType:any;
static setClassificationType = ($this, value) => {
var oldValue = $this.ClassificationType;
$this.ClassificationType = value;
if (value != null) {
}
}
static setInvoicesExpensesClassificationDetailType = ($this, value) => {
var oldValue = $this.InvoicesExpensesClassificationDetailType;
$this.InvoicesExpensesClassificationDetailType = value;
if (value != null) {
if (oldValue != null) {
Domain.InvoicesExpensesClassificationDetailType.removeExpensesClassificationDetailData(oldValue, $this);
}
Domain.InvoicesExpensesClassificationDetailType.addExpensesClassificationDetailData(value, $this);
}
}
static setERPInvoiceCategory = ($this, value) => {
var oldValue = $this.ERPInvoiceCategory;
$this.ERPInvoiceCategory = value;
if (value != null) {
}
}
static setERPInvoiceType = ($this, value) => {
var oldValue = $this.ERPInvoiceType;
$this.ERPInvoiceType = value;
if (value != null) {
}
}
static setClassificationCategory = ($this, value) => {
var oldValue = $this.ClassificationCategory;
$this.ClassificationCategory = value;
if (value != null) {
}
}
static setInvoiceSummaryType = ($this, value) => {
var oldValue = $this.InvoiceSummaryType;
$this.InvoiceSummaryType = value;
if (value != null) {
if (oldValue != null) {
Domain.InvoiceSummaryType.removeExpensesClassification(oldValue, $this);
}
Domain.InvoiceSummaryType.addExpensesClassification(value, $this);
}
}

static GetGetClassificationType($this: any): any{if ($this?.ClassificationType == null) {return "";}
let index = $this?.ClassificationType?.Description?.indexOf(" ");
return (CLMS.Framework.Number.GreaterThan(() => index, () => -1) ? $this?.ClassificationType?.Description?.substr(0, index) : $this?.ClassificationType?.Description);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}